
import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, ArrowRight, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const PaymentFail = () => {
  return (
    <div className="min-h-screen bg-wax-50 pt-24 pb-16 px-4">
      <div className="container mx-auto max-w-3xl">
        <Card className="bg-white shadow-lg rounded-2xl overflow-hidden">
          <CardContent className="p-0">
            <div className="bg-red-500 p-6 flex justify-center">
              <div className="w-20 h-20 rounded-full bg-white flex items-center justify-center">
                <AlertCircle size={40} className="text-red-500" />
              </div>
            </div>
            <div className="p-8 text-center">
              <h1 className="font-cormorant-garamond text-3xl font-bold mb-4">Платеж не выполнен</h1>
              <p className="text-gray-600 mb-6">
                К сожалению, возникла проблема при обработке вашего платежа.
                Ваш заказ не был оплачен и платеж не был проведен.
              </p>

              <div className="bg-gray-50 border border-gray-200 p-6 rounded-lg mb-6">
                <h3 className="font-medium text-lg mb-2">Возможные причины:</h3>
                <ul className="text-left text-gray-700 space-y-2">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Недостаточно средств на карте</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Проблема с подключением к платежной системе</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Банк отклонил операцию из соображений безопасности</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Введены неверные данные карты</span>
                  </li>
                </ul>
              </div>

              <p className="text-gray-700 mb-8">
                Вы можете повторить попытку оплаты или связаться с нами для получения помощи.
              </p>

              <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8">
                <Button variant="default" className="bg-honey-500 hover:bg-honey-600 text-black w-full sm:w-auto flex items-center"
                  onClick={() => window.history.back()}>
                  <RefreshCw size={16} className="mr-2" />
                  Повторить попытку
                </Button>
                <Link to="/">
                  <Button variant="outline" className="border-honey-300 hover:bg-honey-50 text-honey-800 w-full sm:w-auto">
                    Вернуться на главную
                    <ArrowRight size={16} className="ml-2" />
                  </Button>
                </Link>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentFail;
